import { SVGProps } from 'react'

const CarbohydratesSvg = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={60}
        height={60}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect opacity={0.102} width={60} height={60} rx={6} fill="#F9CE23" />
        <path
            d="M37.657 35.1c-.432.957-.638 1.385-1.196 2.231-.776 1.181-1.87 2.654-3.226 2.666-1.205.012-1.515-.783-3.15-.775-1.635.01-1.977.79-3.183.778-1.356-.013-2.392-1.341-3.17-2.524-2.17-3.305-2.397-7.182-1.058-9.243.951-1.467 2.452-2.323 3.865-2.323 1.437 0 2.34.788 3.528.788 1.153 0 1.855-.79 3.518-.79 1.256 0 2.587.684 3.535 1.866-3.106 1.703-2.601 6.14.538 7.326Z"
            fill="#FDCC0C"
        />
        <path
            d="M22.843 35.1c.432.957.639 1.385 1.196 2.231.776 1.181 1.87 2.654 3.226 2.666 1.205.012 1.515-.783 3.15-.775 1.635.01 1.978.79 3.183.778 1.356-.013 2.392-1.341 3.17-2.524 2.17-3.305 2.397-7.182 1.059-9.243-.952-1.467-2.453-2.323-3.865-2.323-1.438 0-2.34.788-3.53.788-1.152 0-1.854-.79-3.517-.79-1.256 0-2.587.684-3.535 1.866 3.107 1.703 2.602 6.14-.537 7.326ZM33.005 23.374c.682-.875 1.2-2.111 1.011-3.374-1.113.076-2.416.785-3.177 1.709-.69.838-1.26 2.082-1.039 3.291 1.216.038 2.474-.689 3.205-1.626Z"
            fill="#FDCC0C"
        />
    </svg>
)

export default CarbohydratesSvg
